import React, { useState, useMemo, useEffect, useRef } from "react";
import { MDBIcon, MDBLoadingManagement, MDBTooltip, MDBSwitch  } from "mdb-react-ui-kit";
import CommonViewLayout from "./CommonViewLayout";
import ExportDropdown from "../CommonViewComponents/ExportDropdown";
import Actions from "../CommonViewComponents/Actions";
import usePermissionForPages from "../../../Hooks/usePermissionForPages";
import { useTranslation } from "../../../Context/TranslationContext";
import DataTable from "../../../Components/Datatable/DataTable";
import MerlinModal from "../Merlin/MerlinModal";
import useAxiosCall from "../../../Hooks/useAxiosCall";
import { useLoadingOverlay } from "../../../Context/LoadingOverlayContext";
import { decryptData, encryptData } from "../../../Utilities/CryptoUtility";
import { SecureStorage } from '../../../Utilities/StorageEncryption';
const Owner = () => {
  const [data, setData] = useState({ columns: [], rows: [] });
  const basicRef = useRef(null);
  const [isLoaderOpen, setIsLoaderOpen] = useState(false);
  const { translations } = useTranslation();
  const { isVisible } = useLoadingOverlay();
  let isMainLoaderVisible = isVisible;
  usePermissionForPages(['OwnerPortal'], '/portal/home');
  const [tableState, setTableState] = useState({
    pageNumber: 1,
    pageSize: 10,//move to env
    sortColumn: '',
    sortDirection: '',
    searchValues: [],
  });

  const [isChecked, setIsChecked] = useState(true);

  const handleToggleChange = () => {
    setToggle(prevValue => !prevValue);
    const updateTableState = (prevTableState, isCurrentlyChecked) => {
      if (!isCurrentlyChecked) {
        return { ...prevTableState, pageNumber: 1 };
      }
  
      const updatedSearchValues = prevTableState.searchValues.filter(obj => 
        !(obj.filterColumn === "inactive" && obj.filterValue === "No")
      );
  
      return {
        ...prevTableState,
        searchValues: updatedSearchValues,
        pageNumber: 1
      };
    };
  
    setIsChecked(prevChecked => {
      setTableState(prevTableState => updateTableState(prevTableState, prevChecked));
      return !prevChecked;
    });
  };

  useEffect(() => {
    getOwnerPortalData();
  }, [tableState, isChecked]);

  const handleApiCallSuccess = (encryptedData) => {
    let data = decryptData(encryptedData.data);
    data = data.residents;
    const transformedColumns = [
      {
        caption: "Actions",
        defaultValue: null,
        fieldName: "actions",
        fieldType: null,
        filterType: null,
        filterValues: null,
        sortable: false,
        visible: "Yes"
      },
      ...data.columns
    ];
    const transformedRows = data.rows.map((detail, i) => {
      let actionParams = {'portal' : "owner", 'sFileAsName' : detail.company, 'pendingPasswordChange' : detail.pendingPasswordChange};
      return{...detail,
        actions: <Actions index={i} userName={detail.name} email={detail.portalEmail} portal="owner" actionParams={actionParams}/>,}
    });
    setData({ columns: transformedColumns, rows: transformedRows, totalRecords: data.totalRecords });
    let columnsData = transformedColumns.map((item) => {
      return item.fieldName;
    })
    setSelectedColumns(columnsData);
    const visibleColumns = transformedColumns.filter(column => column.visible === "Yes");
    setMerlinColumns(visibleColumns);
  };

  const handleApiCallError = (errorMessage) => {
    console.log(errorMessage);
  };

  const { makeApiCall } = useAxiosCall();

  const getOwnerPortalData = async () => {
    let searchVal = tableState.searchValues;
    if (isChecked == true) {
      let newObj = {
        filter: "ListValue",
        filterColumn: "inactive",
        filterValue: isChecked ? "No" : ""
      };
      searchVal.push(newObj);
    }
    const indexToRemove = searchVal.findIndex(obj => obj.filterColumn === "inactive");
    if (indexToRemove !== -1 && isChecked == false ) {
      searchVal.splice(indexToRemove, 1);
    }
    const requestData = {
      data: encryptData(JSON.stringify(
        {
          page: tableState.pageNumber,
          pageSize: tableState.pageSize,
          sortColumn: tableState.sortColumn,
          sortDirection: tableState.sortDirection,
          searchValues: searchVal,
          domain: SecureStorage.getItem('domain'),
        }
      ))
    };

    let isRequestCancelled = false;

    try {
      setIsLoaderOpen(true);
      await makeApiCall({
        requestData,
        onSuccess: handleApiCallSuccess,
        onError: handleApiCallError,
        requestType: 'POST',
        url: 'getDataListing/owner',
        loader: false
      });
    } catch (error) {
      if (error.message == 'Request canceled') {
        isRequestCancelled = true;
      } else {
        console.error('API call error:', error);
      }
    } finally {
      if (!isRequestCancelled) {
        setIsLoaderOpen(false)
      }
    }
  };

  const [selectedColumns, setSelectedColumns] = useState([]);
  const [merlinColumns, setMerlinColumns] = useState([]);
  const [toggle, setToggle] = useState(true);

  const [isMerlinModalOpen, setIsMerlinModalOpen] = useState(false);

  const openMerlinModal = () => {
    setIsMerlinModalOpen(true);
  };

  const closeMerlinModal = () => {
    setIsMerlinModalOpen(false);
  };

  const ResidentFilters = useMemo(() => (
    <div className="d-flex align-items-center" style={{ flexWrap: 'wrap' }}>
      <div style={{ minWidth: 'max-content' }}>
        <ExportDropdown noMargin portalType={'owner'} filters={tableState} label={translations.owner ? translations.owner+"s" + " " : "Owner"} />
      </div>
      <div style={{ minWidth: 'max-content', cursor: 'pointer' }} onClick={openMerlinModal}>
        <MDBTooltip tag='span' wrapperProps={{ color: 'secondary' }} title="Settings">
          <MDBIcon fas icon="cogs" style={{ }} />
        </MDBTooltip>
      </div>
      <div style={{ minWidth: 'max-content', cursor: 'pointer', marginLeft:18 }}>
        <div className="switch-container">
          <div className="left-label">All</div>
          <MDBSwitch className="custom-switch" checked={isChecked} onChange={handleToggleChange} />
          <div className="right-label">Active</div>
        </div>
      </div>
    </div>
  ), [tableState,isChecked]);

  const handleSort = (column, direction) => {
    setTableState((prev) => ({
      ...prev,
      pageNumber: 1,
      sortColumn: column,
      sortDirection: direction,
    }));
  };

  const handleSearch = (searchValues) => {
    setTableState((prev) => ({
      ...prev,
      pageNumber: 1,
      searchValues,
    }));
  };


  const handlePageChange = (pageNumber) => {
    setTableState((prev) => ({
      ...prev,
      pageNumber,
    }));
  };
  const handleRowsPerPageChange = (size) => {
    setTableState((prev) => ({
      ...prev,
      pageSize : size,
    }));
  };
  return (
    <CommonViewLayout
      headerTitle={translations.owner ? translations.owner + "s" : "Owners"}
      filters={ResidentFilters}
      iconName="holly-berry"
      isReport={true}
    >
      <DataTable
        data={data}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleRowsPerPageChange}
        onSort={handleSort}
        onSearch={handleSearch}
        portal={'owner'}
        search={true}
        toggleButton={toggle}
      />
      {isMerlinModalOpen && (
        <MerlinModal
          isOpen={isMerlinModalOpen}
          onClose={closeMerlinModal}
          columns={merlinColumns}
          selectedColumns={selectedColumns}
          setSelectedColumns={setSelectedColumns}
          portal={'owner'}
        />
      )}
      {(isLoaderOpen && isMainLoaderVisible != true) &&
        <MDBLoadingManagement parentRef={basicRef} backdrop={false} loadingText="" backdropOpacity={0} />
      }
    </CommonViewLayout>
  );
};

export default Owner;
